import * as React from 'react';
import { connect } from 'react-redux';
import ConfigDetailLoadStates from './configDetailLoadStates';
import * as Creators from '../actions/creators';
class ConfigDetailLoader extends React.Component {
    constructor(props) {
        const { configNameStream, loadConfig } = props;
        super(props);
        this.subscription = configNameStream.subscribe(loadConfig);
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
    }
    render() {
        return React.createElement(ConfigDetailLoadStates, null);
    }
}
function mapDispatchToProps(dispatch) {
    return {
        loadConfig: (stateParams) => {
            if (stateParams.copy) {
                dispatch(Creators.copySelectedConfig());
            }
            else if (stateParams.new) {
                dispatch(Creators.createNewConfig());
            }
            else if (stateParams.id) {
                dispatch(Creators.loadConfigRequest({ id: stateParams.id }));
            }
        },
    };
}
export default connect(null, mapDispatchToProps)(ConfigDetailLoader);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnRGV0YWlsTG9hZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2theWVudGEvZWRpdC9jb25maWdEZXRhaWxMb2FkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBRS9CLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFJdEMsT0FBTyxzQkFBc0IsTUFBTSwwQkFBMEIsQ0FBQztBQUM5RCxPQUFPLEtBQUssUUFBUSxNQUFNLHFCQUFxQixDQUFDO0FBb0JoRCxNQUFNLGtCQUFtQixTQUFRLEtBQUssQ0FBQyxTQUFxRTtJQUcxRyxZQUFZLEtBQWlFO1FBQzNFLE1BQU0sRUFBRSxnQkFBZ0IsRUFBRSxVQUFVLEVBQUUsR0FBRyxLQUFLLENBQUM7UUFDL0MsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ2IsSUFBSSxDQUFDLFlBQVksR0FBRyxnQkFBZ0IsQ0FBQyxTQUFTLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDN0QsQ0FBQztJQUVNLG9CQUFvQjtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBQ2xDLENBQUM7SUFFTSxNQUFNO1FBQ1gsT0FBTyxvQkFBQyxzQkFBc0IsT0FBRyxDQUFDO0lBQ3BDLENBQUM7Q0FDRjtBQUVELFNBQVMsa0JBQWtCLENBQUMsUUFBd0M7SUFDbEUsT0FBTztRQUNMLFVBQVUsRUFBRSxDQUFDLFdBQXFDLEVBQUUsRUFBRTtZQUNwRCxJQUFJLFdBQVcsQ0FBQyxJQUFJLEVBQUU7Z0JBQ3BCLFFBQVEsQ0FBQyxRQUFRLENBQUMsa0JBQWtCLEVBQUUsQ0FBQyxDQUFDO2FBQ3pDO2lCQUFNLElBQUksV0FBVyxDQUFDLEdBQUcsRUFBRTtnQkFDMUIsUUFBUSxDQUFDLFFBQVEsQ0FBQyxlQUFlLEVBQUUsQ0FBQyxDQUFDO2FBQ3RDO2lCQUFNLElBQUksV0FBVyxDQUFDLEVBQUUsRUFBRTtnQkFDekIsUUFBUSxDQUFDLFFBQVEsQ0FBQyxpQkFBaUIsQ0FBQyxFQUFFLEVBQUUsRUFBRSxXQUFXLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO2FBQzlEO1FBQ0gsQ0FBQztLQUNGLENBQUM7QUFDSixDQUFDO0FBRUQsZUFBZSxPQUFPLENBQUMsSUFBSSxFQUFFLGtCQUFrQixDQUFDLENBQUMsa0JBQWtCLENBQUMsQ0FBQyJ9